/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramReviewsUserControllerCreateMutationRequest,
  TelegramReviewsUserControllerCreateMutationResponse,
  TelegramReviewsUserControllerCreate401,
} from '../../types/TelegramReviewsUserControllerCreate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramReviewsUserCreate } from '../../methods/telegramReviewsUserCreate.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramReviewsUserCreateMutationKey = () => [{ url: '/api/user/telegram/reviews' }] as const;

export type TelegramReviewsUserCreateMutationKey = ReturnType<typeof telegramReviewsUserCreateMutationKey>;

/**
 * {@link /api/user/telegram/reviews}
 */
export function useTelegramReviewsUserCreate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramReviewsUserControllerCreateMutationResponse,
      ResponseErrorConfig<TelegramReviewsUserControllerCreate401>,
      { data: TelegramReviewsUserControllerCreateMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramReviewsUserControllerCreateMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramReviewsUserCreateMutationKey();

  return useMutation<
    TelegramReviewsUserControllerCreateMutationResponse,
    ResponseErrorConfig<TelegramReviewsUserControllerCreate401>,
    { data: TelegramReviewsUserControllerCreateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramReviewsUserCreate(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
